import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeIS from '@angular/common/locales/is';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { provideFuse } from '@fuse';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FuseCardComponent } from '@fuse/components/card';
import { AppComponent } from 'app/app-base/app.component';
import { appConfig } from 'app/fuse-template/core/config/app.config';
import { CoreModule } from 'app/fuse-template/core/core.module';
import { LsrCommonModule } from 'common/common.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MarkdownModule } from 'ngx-markdown';
import { AlertComponent } from './components/alert/alert.component';
import { ApplicationsManualStatisticsComponent } from './components/applications/manual-statistics/applications-manual-statistics.component';
import { CoredataDocumentInputComponent } from './components/applications/pension-other-funds/coredata-document-input/coredata-document-input.component';
import { PensionOtherFundsComponent } from './components/applications/pension-other-funds/pension-other-funds.component';
import { PensionRetirementFormComponent } from './components/applications/pension-other-funds/retirement-form/pension-retirement-form.component';
import { PensionSpouseFormComponent } from './components/applications/pension-other-funds/spouse-form/pension-spouse-form.component';
import { AssistAzureComponent } from './components/assists/azure/assists-azure.component';
import { AssistsInterestRegisterComponent } from './components/assists/interest-register/assists-interest-register.component';
import { InterestRegisterEntryTypeCardComponent } from './components/assists/interest-register/components/entry-type-card/entry-type-card.component';
import { InterestRegisterDetailComponent } from './components/assists/interest-register/components/interest-register-detail/interest-register-detail.component';
import { InterestRegisterFormComponent } from './components/assists/interest-register/components/interest-register-form/interest-register-form.component';
import { InterestRegisterListComponent } from './components/assists/interest-register/components/interest-register-list/interest-register-list.component';
import { ConflictOfInterestFormComponent } from './components/assists/interest-register/forms/conflict-of-interest-form/conflict-of-interest-form.component';
import { EmploymentOrBoardParticipationFormComponent } from './components/assists/interest-register/forms/employment-or-board-participation-form/employment-or-board-participation-form.component';
import { GiftOrTravelFormComponent } from './components/assists/interest-register/forms/gift-or-travel-form/gift-or-travel-form.component';
import { InterdepartmentTradingFormComponent } from './components/assists/interest-register/forms/interdepartment-trading-form/interdepartment-trading-form.component';
import { SecuritiesTradingFormComponent } from './components/assists/interest-register/forms/securities-trading-form/securities-trading-form.component';
import { AssistsJiraAtvikComponent } from './components/assists/jira/atvik/assists-jira-atvik.component';
import { AssistsJiraBvhComponent } from './components/assists/jira/bvh/assists-jira-bvh.component';
import { AssistsJiraEAComponent } from './components/assists/jira/ea/assists-jira-ea.component';
import { AssistsJiraStsComponent } from './components/assists/jira/sts/assists-jira-sts.component';
import { AssistsJiraUtComponent } from './components/assists/jira/ut/assists-jira-ut.component';
import { AssistsOverviewComponent } from './components/assists/overview/assists-overview.component';
import { AudkenningSendaBeidniComponent } from './components/audkenning/senda-beidni/audkenning-senda-beidni.component';
import { AudkenningSkodaBeidnirComponent } from './components/audkenning/skoda-beidnir/audkenning-skoda-beidnir.component';
import { BakvordurComponent } from './components/bakvordur/bakvordur.component';
import { DocumentsAddGeneralInfoComponent } from './components/documents/documents-add/documents-add-general-info/documents-add-general-info.component';
import { DocumentsAddMultipleSystemKriaComponent } from './components/documents/documents-add/documents-add-multiple/document-add-multiple-system/kria/documents-add-multiple-system-kria.component';
import { DocumentsAddMultipleSystemPortalLsrComponent } from './components/documents/documents-add/documents-add-multiple/document-add-multiple-system/portal-lsr/documents-add-multiple-system-portal-lsr.component';
import { DocumentsAddMultipleComponent } from './components/documents/documents-add/documents-add-multiple/documents-add-multiple.component';
import { DocumentsAddSingleComponent } from './components/documents/documents-add/documents-add-single/documents-add-single.component';
import { DocumentsAddComponent } from './components/documents/documents-add/documents-add.component';
import { DocumentsJobsComponent } from './components/documents/documents-jobs/documents-jobs.component';
import { DocumentsOverviewComponent } from './components/documents/documents-overview/documents-overview.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { GengiSkraComponent } from './components/gengi/skra/gengi-skra.component';
import { GroupsComponent } from './components/groups/groups.component';
import { AzureEnvironmentReservationsAddComponent } from './components/it/azure-environment-reservations/add/azure-environment-reservations-add.component';
import { AzureEnvironmentReservationsComponent } from './components/it/azure-environment-reservations/azure-environment-reservations.component';
import { AzureEnvironmentReservationsListComponent } from './components/it/azure-environment-reservations/list/azure-environment-reservations-list.component';
import { JobDetailsComponent } from './components/jobs/job-details.component';
import { LoaderInlineComponent } from './components/loader/inline/loader-inline.component';
import { LoaderMainComponent } from './components/loader/main/loader-main.component';
import { LoansFMEReport } from './components/loans/fme-report/loans-fme-report.component';
import { LoansMortgageEligibilityFormListComponent } from './components/loans/mortgage-eligibility/mortgage-eligibility-form-list/loans-mortgage-eligibility-form-list.component';
import { LoansMortgageEligibilityFormPropertyHistoricalDocumentsComponent } from './components/loans/mortgage-eligibility/mortgage-eligibiliy-form/historical-documents/loans-mortgage-eligibility-form-property-historical-documents.component';
import { LoansMortgageEligibilityFormComponent } from './components/loans/mortgage-eligibility/mortgage-eligibiliy-form/loans-mortgage-eligibility-form.component';
import { LogsComponent } from './components/logs/logs.component';
import { PensionCoefficientsAcquisitionComponent } from './components/pension/coefficients/acquisition/pension-coefficients-acquisition.component';
import { PensionCoefficientsPayoutComponent } from './components/pension/coefficients/payout/pension-coefficients-payout.component';
import { PensionCoefficientsComponent } from './components/pension/coefficients/pension-coefficients.component';
import { PensionDivisionOfRulingsComponent } from './components/pension/division-of-rulings/pension-division-of-rulings.component';
import { PensionIncreaseClaimsComponent } from './components/pension/increase-claims/pension-increase-claims.component';
import { PensionPaycheckRunsComponent } from './components/pension/paychecks/pension-paycheck-runs.component';
import { PensionPaycheckRunsPrintComponent } from './components/pension/paychecks/print/pension-paycheck-runs-print.component';
import { PendingTaxUpdatesComponent } from './components/pension/pending-tax-updates/pending-tax-updates.component';
import { PensionStateResponsibilityGroupComponent } from './components/pension/state-responsibility-group/pension-state-responsibility-group.component';
import { ReportsPowerBIComponent } from './components/reports/powerbi/reports-powerbi.component';
import { SettingsConfigsAssistsComponent } from './components/settings/configs/assists/settings-configs-assists.component';
import { SettingsConfigsConfigsComponent } from './components/settings/configs/configs/settings-configs-configs.component';
import { SettingsConfigsComponent } from './components/settings/configs/settings-configs.component';
import { ServiceusersComponent } from './components/settings/serviceusers/settings-serviceusers.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SettingsTranslationsComponent } from './components/settings/translations/settings-translations.component';
import { SettingsUsersComponent } from './components/settings/users/settings-users.component';
import { SettingsUsersUserProfileComponent } from './components/settings/users/user/profile/settings-users-user-profile.component';
import { SettingsUsersUserRolesComponent } from './components/settings/users/user/roles/settings-users-user-roles.component';
import { SettingsUsersUserComponent } from './components/settings/users/user/settings-users-user.component';
import { ThjodskraComponent } from './components/thjodskra/thjodskra.component';
import { XMLValidationComponent } from './components/xml-validation/xml-validation.component';
import { DialogAudkenningConfirmExtendToken } from './dialogs/audkenning/confirm-extend-token/dialog-audkenning-confirm-extend-token';
import { DialogAudkennigInnskra } from './dialogs/audkenning/innskra/dialog-audkenning-innskra';
import { DialogConfirm } from './dialogs/confirm/dialog-confirm';
import { DialogDocumentsAddMultipleConfirm } from './dialogs/documents/documents-add-multiple-confirm/dialog-documents-add-multiple-confirm';
import { DialogDocumentsAddSingleConfirm } from './dialogs/documents/documents-add-single-confirm/dialog-documents-add-single-confirm';
import { DialogDocumentsOverviewFile } from './dialogs/documents/documents-overview-file/dialog-documents-overview-file';
import { DialogDocumentsKriaOverviewList } from './dialogs/documents/kria/dialog-documents-kria-overviewList';
import { DialogInfo } from './dialogs/info/dialog-info';
import { DialogJobsMessageDetails } from './dialogs/jobs/message-details/dialog-jobs-message-details';
import { DialogMortgageEligibilityAddPropertyComponent } from './dialogs/loans/mortgage-eligibility/add-property/dialog-mortgage-eligibility-add-property';
import { DialogMortgageEligibilityConfirmFetchPropertyInfoComponent } from './dialogs/loans/mortgage-eligibility/confirm-fetch-property-info/dialog-mortgage-eligibility-confirm-fetch-property-info';
import { DialogMortgageEligibilityCopyDataComponent } from './dialogs/loans/mortgage-eligibility/copy-data/dialog-mortgage-eligibility-copy-data';
import { DialogMortgageEligibilityCreateComponent } from './dialogs/loans/mortgage-eligibility/create/dialog-mortgage-eligibility-create';
import { DialogMortgageEligibilityMissingOriginatingApplicationComponent } from './dialogs/loans/mortgage-eligibility/missing-originating-application/dialog-mortgage-eligibility-missing-originating-application';
import { DialogPdfViewPdf } from './dialogs/pdf/view/dialog-pdf-view';
import { DialogPensionDivisionOfRulings } from './dialogs/pension/division-of-rulings/dialog-pension-division-of-rulings';
import { DialogPensionIncreaseClaimsCreateResults } from './dialogs/pension/pension-increase-claims-create-results/dialog-pension-increase-claims-create-results.component';
import { DialogSave } from './dialogs/save/dialog-save';
import { DialogSettingsConfigsAdd } from './dialogs/settings/configs/add/dialog-settings-configs-add';
import { DialogSettingsServiceUsersAdd } from './dialogs/settings/serviceusers/add/dialog-settings-serviceusers-add';
import { DialogSettingsServiceUsersDetails } from './dialogs/settings/serviceusers/details/dialog-settings-serviceusers-details';
import { DialogSettingsTranslationsAdd } from './dialogs/settings/translations/add/dialog-settings-translations-add';
import { DialogSettingsUsersAdd } from './dialogs/settings/users/add/dialog-settings-users-add';
import { DialogSettingsUsersDetails } from './dialogs/settings/users/details/dialog-settings-users-details';
import { DialogSettingsUsersSelect } from './dialogs/settings/users/select/dialog-settings-users-select';
import { DialogThjodskraFirmDetails } from './dialogs/thjodskra/firm-details/dialog-thjodskra-firm-details';
import { DialogThjodskraPersonDetails } from './dialogs/thjodskra/person-details/dialog-thjodskra-person-details';
import { IconsModule } from './fuse-template/core/icons/icons.module';
import { LayoutComponent } from './fuse-template/layout/base-layout/layout.component';
import { MockApiService } from './fuse-template/mock-api';
import { AuthSignInComponent } from './fuse-template/modules/auth/sign-in/sign-in.component';
import { SharedModule } from './fuse-template/shared/shared.module';
import { APP_DATE_FORMATS } from './helpers/APP_DATE_FORMATS';
import { AppDateAdapter } from './helpers/appDateAdapter';
import { getIcelandicPaginatorIntl } from './helpers/icelandicPaginatorIntl';
import { MaxRangeDirective } from './helpers/maxRangeDirective';
import { PendingChangesGuard } from './helpers/pendingChangesGuard';
import { AppRoutes } from './routing/app.routing';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

registerLocaleData(localeIS, 'is');

@NgModule({
    declarations: [
        AppComponent,
        DialogAudkenningConfirmExtendToken,
        AlertComponent,
        DialogAudkennigInnskra,
        DialogPdfViewPdf,
        LoaderMainComponent,
        AuthSignInComponent,
        GengiSkraComponent,
        AudkenningSendaBeidniComponent,
        PensionStateResponsibilityGroupComponent,
        PensionCoefficientsComponent,
        PensionCoefficientsAcquisitionComponent,
        PensionCoefficientsPayoutComponent,
        PensionPaycheckRunsComponent,
        PensionPaycheckRunsPrintComponent,
        PendingTaxUpdatesComponent,
        SettingsComponent,
        SettingsUsersComponent,
        AudkenningSkodaBeidnirComponent,
        AssistAzureComponent,
        DialogSettingsUsersDetails,
        DialogSettingsUsersAdd,
        DialogSettingsUsersSelect,
        SettingsConfigsComponent,
        SettingsConfigsAssistsComponent,
        LoansMortgageEligibilityFormComponent,
        LoansMortgageEligibilityFormPropertyHistoricalDocumentsComponent,
        LoansMortgageEligibilityFormListComponent,
        DialogMortgageEligibilityCreateComponent,
        DialogMortgageEligibilityCopyDataComponent,
        DialogMortgageEligibilityMissingOriginatingApplicationComponent,
        DialogMortgageEligibilityConfirmFetchPropertyInfoComponent,
        DialogMortgageEligibilityAddPropertyComponent,
        ReportsPowerBIComponent,
        SettingsUsersComponent,
        SettingsUsersUserComponent,
        SettingsUsersUserProfileComponent,
        BakvordurComponent,
        SettingsUsersUserRolesComponent,
        AssistsJiraEAComponent,
        AssistsOverviewComponent,
        AssistsJiraAtvikComponent,
        AssistsInterestRegisterComponent,
        InterestRegisterEntryTypeCardComponent,
        InterestRegisterFormComponent,
        EmploymentOrBoardParticipationFormComponent,
        ConflictOfInterestFormComponent,
        GiftOrTravelFormComponent,
        InterdepartmentTradingFormComponent,
        SecuritiesTradingFormComponent,
        InterestRegisterListComponent,
        InterestRegisterDetailComponent,
        LoaderInlineComponent,
        AssistsJiraBvhComponent,
        ThjodskraComponent,
        XMLValidationComponent,
        DialogThjodskraFirmDetails,
        DialogThjodskraPersonDetails,
        DialogPensionIncreaseClaimsCreateResults,
        DialogConfirm,
        DialogInfo,
        DialogSave,
        DocumentsComponent,
        DocumentsAddComponent,
        DocumentsJobsComponent,
        DocumentsAddSingleComponent,
        DocumentsAddMultipleSystemKriaComponent,
        DocumentsAddMultipleSystemPortalLsrComponent,
        DocumentsAddGeneralInfoComponent,
        DocumentsAddMultipleComponent,
        DocumentsOverviewComponent,
        JobDetailsComponent,
        MaxRangeDirective,
        LoansFMEReport,
        AssistsJiraUtComponent,
        AssistsJiraStsComponent,
        SettingsConfigsConfigsComponent,
        DialogSettingsConfigsAdd,
        DialogDocumentsKriaOverviewList,
        ServiceusersComponent,
        DialogSettingsServiceUsersAdd,
        DialogSettingsServiceUsersDetails,
        DialogJobsMessageDetails,
        SettingsTranslationsComponent,
        DialogSettingsTranslationsAdd,
        GroupsComponent,
        AzureEnvironmentReservationsComponent,
        AzureEnvironmentReservationsListComponent,
        AzureEnvironmentReservationsAddComponent,
        ApplicationsManualStatisticsComponent,
        CoredataDocumentInputComponent,
        PensionOtherFundsComponent,
        PensionRetirementFormComponent,
        PensionSpouseFormComponent,
        PensionDivisionOfRulingsComponent,
        DialogPensionDivisionOfRulings,
        DialogDocumentsOverviewFile,
        DialogDocumentsAddSingleConfirm,
        DialogDocumentsAddMultipleConfirm,
        PensionIncreaseClaimsComponent,
        LogsComponent,
        FuseCardComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        NgxDropzoneModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, routerConfig),
        // Core module of your application
        CoreModule,
        LsrCommonModule,
        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        MatIconModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatSlideToggleModule,
        MatTooltipModule,
        LayoutComponent,
        MatButtonModule,
        MatRadioModule,
        MatStepperModule,
        CommonModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatDividerModule,
        MatFormFieldModule,
        MatMenuModule,
        MatMomentDateModule,
        SharedModule,
        MatCheckboxModule,
        MatSelectModule,
        CKEditorModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        FormsModule,
        MatDialogModule,
        MatSortModule,
        MatTableModule,
        NgApexchartsModule,
        MatRippleModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatPaginatorModule,
        ScrollingModule,
        OverlayModule,
        PortalModule,
        PdfViewerModule,
        MatExpansionModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatListModule,
        FuseAlertComponent,
        MatIconModule,
        IconsModule,
    ],
    providers: [
        ...provideFuse({
            fuse: appConfig,
            mockApi: {
                delay: 0,
                service: MockApiService,
            },
        }),
        PendingChangesGuard,
        { provide: LOCALE_ID, useValue: 'is-IS' },
        {
            provide: DateAdapter,
            useClass: AppDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        { provide: MatPaginatorIntl, useValue: getIcelandicPaginatorIntl() },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
